import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory();

export const ACTION_LOG_CLEAR = 'ACTION_LOG_CLEAR';
export const actionLogClear = actionCreator<string>(ACTION_LOG_CLEAR);